import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateNomenclaturesFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateNomenclaturesFromEntity
  implements UpdateNomenclaturesFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UpdateNomenclaturesFromEntityUseCaseInterface.Params,
  ): Promise<UpdateNomenclaturesFromEntityUseCaseInterface.Result> {
    const { entityId, data } = params;
    const requestUrl = `${this.url}/${entityId}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      body: data,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
